/** Поле телефона в форме (Enter здесь не переключает фокус, но на него можно перейти Enter-ом). */
export function isPhoneField(el) {
  if (!(el instanceof Element)) return false;
  if (el.closest('[data-phone-input]')) return true;
  if (el instanceof HTMLInputElement) {
    const type = (el.type || '').toLowerCase();
    const mode = (el.inputMode || el.getAttribute('inputmode') || '').toLowerCase();
    if (type === 'tel' || mode === 'tel') return true;
  }
  return false;
}

export function getModalScrollContainer(el) {
  if (!(el instanceof Element)) return null;
  return el.closest('[data-modal-scroll-body], .chakra-modal__body, [role="dialog"]');
}
